import React, { ReactNode } from 'react';
import { useNewsBriefing } from '../_context/NewsContext';
import { useSafeAreaSpacing } from '@/hooks/useSafeAreaSpacing';

interface LayoutProps {
  children: ReactNode;
}

export const LayoutNewsBriefingSwiper: React.FC<LayoutProps> = ({ children }) => {
  const { isLoading } = useNewsBriefing();
  const { getBottomSpacing } = useSafeAreaSpacing();

  return (
    <section
      className={`flex h-[100dvh] w-full flex-col items-center justify-center gap-[24px] bg-gr-50 px-[20px] ${
        isLoading ? 'pt-[13px]' : 'pt-[28px]'
      }`}
      style={{ paddingBottom: getBottomSpacing() }}
    >
      {children}
    </section>
  );
};

export const LayoutSwiperTop: React.FC<LayoutProps> = ({ children }) => {
  return <div className="flex h-full w-full flex-1 flex-col gap-[16px]">{children}</div>;
};

export const LayoutTopContent: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="group flex h-full min-h-[300px] w-full flex-1  flex-col  ">{children}</div>
  );
};

export const LayoutBottomContent: React.FC<LayoutProps> = ({ children }) => {
  return <div className="flex min-h-[6px] w-full items-center justify-center">{children}</div>;
};
